import React from "react";
import { FileText } from "lucide-react";

/**
 * Compact secondary meta for history/review list rows.
 * Value-first: date · template chip · filename — omit missing fields.
 */
const DocumentMetaLine = ({ doc, isDarkMode, dateTime }) => {
  const templateName = doc.template_name || doc.template;
  const filename = doc.filename;

  const metaParts = [];
  if (dateTime) metaParts.push({ key: "date", node: dateTime });
  if (templateName) {
    metaParts.push({
      key: "template",
      node: (
        <span
          className={`inline-flex items-center max-w-[14rem] truncate rounded px-1.5 py-0.5 text-[11px] font-medium ${
            isDarkMode
              ? "bg-slate-800 text-slate-300"
              : "bg-slate-200/80 text-slate-600"
          }`}
          title={templateName}
        >
          {templateName}
        </span>
      ),
    });
  }
  if (filename) {
    metaParts.push({
      key: "filename",
      node: (
        <span
          className={`inline-flex items-center gap-1 min-w-0 max-w-[18rem] ${
            isDarkMode ? "text-gray-400" : "text-gray-500"
          }`}
          title={filename}
        >
          <FileText size={12} className="shrink-0 opacity-70" />
          <span className="truncate">{filename}</span>
        </span>
      ),
    });
  }

  if (metaParts.length === 0) return null;

  return (
    <div
      className={`mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs ${
        isDarkMode ? "text-gray-400" : "text-gray-500"
      }`}
    >
      {metaParts.map((part, index) => (
        <React.Fragment key={part.key}>
          {index > 0 && (
            <span
              className={`select-none ${
                isDarkMode ? "text-gray-600" : "text-gray-300"
              }`}
              aria-hidden="true"
            >
              ·
            </span>
          )}
          {part.node}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DocumentMetaLine;
